import { useState } from 'react';
import { Button, Snackbar, Alert, Box } from '@mui/material';
import { useGoogleLogin } from '@react-oauth/google';
import { googleRegister } from '../services/authService';
import googleIcon from '../assets/logos/icons-google-48.svg';

export default function GoogleSignUpButton() {
    const [error, setError] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const showError = (message) => {
        setError(message);
        setOpenSnackbar(true);
    };

    const getErrorMessage = (error) => (
        error?.response?.data?.message ||
        error?.message ||
        'Google login failed'
    );
    
    // google Register Section
    const googleRegisterOnClick = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                if (!tokenResponse?.access_token) {
                    throw new Error('Google login failed');
                }

                // Decode the JWT token to get user profile data
                const response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: {
                        Authorization: `Bearer ${tokenResponse.access_token}`,
                    },
                });
                if (!response.ok) {
                    throw new Error('Failed to fetch Google profile');
                }

                const userProfile = await response.json();
                const authResult = await googleRegister(userProfile);
                if(authResult.status === 'success') {
                    localStorage.setItem('userInfo', JSON.stringify(authResult.data));
                    window.location.href = '/dashboard';
                } else {
                    showError(authResult.message);
                }
            } catch (error) {
                showError(getErrorMessage(error));
            }
        },
        onError: () => {
            showError('Google login failed');
        }
    });

    return (
        <>
            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                <Button 
          variant="outlined"
          sx={{
            flex: 1,
            borderRadius: 2,
            fontSize: '0.75rem',
            color: '#18181b',
            borderColor:"#1ce484", 
            boxShadow: '0 4px 24px 0 rgba(56, 65, 74, 0.07)',
            '&:hover': {
              background: '#f1f5f9',
              borderColor: '#3b82f6',
            },
          }}
          startIcon={
            <img
              src={googleIcon}
              alt="Google"
              style={{ width: 25, height: 25 }}
            />
          }
          onClick={() => googleRegisterOnClick()}
        >
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            Sign Up with Google
          </Box>
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            Google
          </Box>
        </Button>

      </Box>

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>{error}</Alert>
      </Snackbar>
    </>
  );
}
